var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentityVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qc0o0dnafa",
    d: "M14.086 4.003c.189 0 .377.155.51.434.762 1.6 1.525 3.212 2.26 4.822.07.19.238.323.433.34 1.702.267 3.404.534 5.108.784.28.03.511.245.572.533.081.262-.001.548-.206.72-1.203 1.215-2.401 2.438-3.61 3.648-.151.132-.217.344-.167.544.3 1.732.577 3.464.865 5.202.05.304.081.605-.196.816-.265.197-.62.197-.885 0-1.491-.835-2.992-1.647-4.485-2.476-.144-.097-.33-.097-.473 0-1.501.837-3.01 1.657-4.51 2.497-.25.177-.58.177-.83 0-.285-.197-.28-.49-.229-.8.288-1.767.568-3.533.873-5.298.041-.163-.011-.337-.135-.445-1.22-1.228-2.437-2.46-3.648-3.699-.118-.115-.216-.253-.287-.405-.072-.176-.059-.377.036-.54.095-.163.26-.268.442-.28.59-.118 1.186-.2 1.78-.291 1.148-.179 2.29-.347 3.445-.533.153-.046.28-.158.351-.307.768-1.599 1.526-3.205 2.274-4.818.12-.296.407-.477.712-.448z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-922 -615) translate(922 615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "lj99hhy72b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qc0o0dnafa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.3,
    d: "M13.315 3.555c1.1-.256 1.287-.104 1.424.024l.047.044c.146.124.286.302.396.534.76 1.595 1.522 3.203 2.256 4.808 1.68.263 3.361.526 5.044.774.276.033.528.153.726.338.188.175.328.408.39.676.07.245.068.5 0 .736-.068.238-.202.455-.391.623h0l-1.27 1.286c-.768.778-1.536 1.557-2.309 2.33.213 1.23.415 2.46.617 3.692l.247 1.503c.044.264.061.524.005.759-.06.252-.192.486-.454.685-.248.185-.54.277-.83.277-.277 0-.553-.083-.793-.25-.84-.469-1.683-.932-2.525-1.395-.55-.301-1.099-.603-1.647-.906-1.798.779-3.206 1.545-4.605 2.328-.23.153-.493.229-.756.229-.276 0-.552-.084-.785-.249-.269-.186-.412-.415-.483-.666-.067-.234-.062-.499-.017-.772l.195-1.207c.206-1.269.41-2.538.628-3.805-1.22-1.484-2.33-2.618-3.432-3.744-.41-.55-.523-.812-.574-1.002-.107-.405-.021-.641.102-.852.197-.34.536-.556.91-.598.48-.094.964-.167 1.449-.24l1.605-.245c.617-.094 1.236-.188 1.857-.288 1.022-1.766 1.735-3.278 2.438-4.795.114-.27.304-.487.535-.632z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#49A9FC",
    mask: "url(#lj99hhy72b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0z",
    transform: "translate(-.022)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M17.658 12.51c-1.348 1.298-2.7 2.6-4.054 3.908-.121.116-.237.248-.364.348-.162.154-.383.238-.611.234-.228-.004-.445-.097-.602-.257-.584-.557-1.162-1.116-1.734-1.678-.24-.203-.344-.518-.269-.818.075-.3.317-.535.627-.61.31-.076.639.02.853.25.198.18.387.366.575.555.188.188.354.365.558.576l3.24-3.14c.192-.183.383-.37.576-.55.423-.404.932-.436 1.29-.09.36.345.351.855-.085 1.272z",
    mask: "url(#lj99hhy72b)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityVerified);
export default __webpack_public_path__ + "static/media/identity-verified.2175dd00.svg";
export { ForwardRef as ReactComponent };